import { SpacesModel } from '../models/spaces.model';
import RequestCreator from './helpers/requestCreator';

class Space extends RequestCreator<SpacesModel> {}

const api = new Space('/spaces');
export default api;
